import { put,takeLatest } from "redux-saga/effects";
import { LOAD_USERS, UPDATE_USER } from "./constants";
import {
  loadUsersSuccess,
  loadUsersError,
  updateUserSuccess,
  updateUserError,
} from "./actions";

import { notification } from "antd";
import i18n from 'i18next';

import history from "utils/history";
import requestWrapper from "utils/requestWrapper";
import _local from "utils/localStorageUtils";
import api from "utils/api";
const { endpoint } = api;

export function* loadUsers() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();

    // we get the campaigns linked to the user
    const usersList = yield requestWrapper(
      "GET",
      endpoint?.users?.list,
      "",
      currentUser.token,
    );

    if (!usersList) {
      yield put(loadUsersSuccess(false));
    } else {
      const firstElem = usersList.data[0];
      yield put(loadUsersSuccess(usersList, firstElem));
    }
  } catch (error) {
    yield put(loadUsersError(error));
  }
}

export function* updateUser(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { userDetail, actionType } = action;

    let updatedUser = false,
      isNew = !userDetail?._id;

    if (isNew) {
      let userDetailModified = { ...userDetail };
      userDetailModified.sendConfirmEmail = false;
      updatedUser = yield requestWrapper(
        "POST",
        endpoint?.users?.new,
        userDetailModified,
        currentUser.token,
      );
    } else {
      updatedUser = yield requestWrapper(
        "PATCH",
        endpoint?.users?.update,
        {
          user: userDetail,
          actionType,
        },
        currentUser.token,
      );
    }

    // console.debug(updatedUser);

    if (updatedUser === false) {
      yield put(updateUserSuccess(false));
      notification.success({ message: i18n.t("notifications.somethingWrong") });
    } else {
      notification.success({ message: i18n.t("notifications.dataSaved") });
      // if new we update the url, item props will be updated
      if (isNew) {
        history.push({ pathname: `/utilisateurs/${updatedUser?._id}` });
      }
      yield put(updateUserSuccess(updatedUser));
    }
  } catch (err) {
    yield put(updateUserError(err));
  }
}

// Individual exports for testing
export default function* usersSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_USERS, loadUsers);
  yield takeLatest(UPDATE_USER, updateUser);
}
